import axios from 'axios';
import Vue from 'vue';
import  { autoLogOutTimeSet } from '@common/helpers/auto-logout';

const hostname = window.location.host;
const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1:8080');
const baseURL = isDevelopment ? 'http://localhost:11101/api/erp/' : '/api/erp/';

const tmsErpAxiosInstance = axios.create({ baseURL, timeout: 1800000 });

tmsErpAxiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem('tsm-user-token');
  const isLogin = window.location.pathname === '/login';
  if ((token && token !== 'undefined')) { //  && !isLogin) {
    config.headers = { Authorization: `bearer ${token}` }; // eslint-disable-line
  }
  return config;
}, error => Promise.reject(error));

tmsErpAxiosInstance.interceptors.response.use((response) => {
  const token = response.headers['x-auth-token'];
  autoLogOutTimeSet(response.status);
  if (token) {
    localStorage.setItem('tsm-user-token', token);
  }
  return (response.data) ? response.data : response;
}, error => Promise.reject(error.response));

Vue.prototype.$tmsErpAxios = tmsErpAxiosInstance;

export default tmsErpAxiosInstance;
